import { Component, NgZone, OnInit } from '@angular/core';
import * as  apiVeranstaltungen from '../../../../clients/veranstaltungen';
import { Aufgabe } from '../../../../clients/veranstaltungen';
import { Observable } from 'rxjs/Observable';
import { select, Store } from '@ngrx/store';
import * as fromAufgabenPage from './aufgabe.reducer';
import * as fromAppState from '../../app-state/app-state.reducer';
import { getPlatform } from '../../app-state/app-state.reducer';
import * as actionsUi from './aufgabe.actions.ui';
import { ResponseContentType } from '@angular/http';
import { Subscription } from 'rxjs/Subscription';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ImageService } from '@orga-app/providers/image.service';
import { Settings } from '@orga-app/settings/settings.model';
import { AlertController, ModalController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { WindowRefService } from '@orga-app/providers/window.service';
import { GetAufgabeDetailAction, GetFunktionsbereichChecklistenAufgabenAction, PostAufgabeFreigebenAction, PostAufgabeNichtOkErfassenAction, PostAufgabeOkErfassenAction } from '../../../../client-ngrx/veranstaltungen';
import { BildVorschauComponent } from '../../../../sopi/components/bild-vorschau/bild-vorschau';
import { catchError, filter, takeUntil, takeWhile } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { SettingsProvider } from '@orga-app/settings/settings.service';
import { AufgabebemerkungPage } from '../../aufgabebemerkung/aufgabebemerkung.page';
import { FehlerbeschreibungPage } from '../../fehlerbeschreibung/fehlerbeschreibung.page';
import { BildInfo } from 'src/app/shared/models/bildInfo';

@Component({
  selector: 'app-aufgaben',
  templateUrl: './aufgabe.page.html'
})
export class AufgabePage implements OnInit { // , AfterViewInit, AfterContentInit, AfterContentChecked, AfterViewChecked {

  public aktuelleVeranstaltung$: Observable<apiVeranstaltungen.Veranstaltung>;
  public veranstaltungBerechtigung$: Observable<apiVeranstaltungen.VeranstaltungBerechtigung>;
  public platformState$: Observable<string>;
  public platformState: string;

  veranstaltungBerechtigung: apiVeranstaltungen.VeranstaltungBerechtigung;
  aufgabe: apiVeranstaltungen.Aufgabe;
  checkliste: apiVeranstaltungen.Checkliste;
  funktionsbereich: apiVeranstaltungen.Funktionsbereich;
  public settings$: Observable<Settings>;
  public themeDefault$: Observable<Settings>;
  logoHeaderSVG$: Observable<SafeUrl>;
  aufgabeBilder$: Observable<Array<BildInfo>>;
  bemerkungBilder$: Observable<BildInfo[]>;
  fehlerBilder$: Observable<BildInfo[]>;
  aufgabeDetail$: Observable<apiVeranstaltungen.AufgabeDetail>;
  public aufgabe$: Observable<apiVeranstaltungen.Aufgabe>;
  public checklisteStatus$: Observable<apiVeranstaltungen.ChecklisteStatus>;
  destroyPage = false;
  getFehler$: Subscription;
  getAufgabe$: Subscription;
  unsubscibe$ = new Subject<void>();
  private aktuelleVeranstaltung: apiVeranstaltungen.Veranstaltung;
  private aktuelleVeranstaltungId: string;
  private aiName = 'AufgabePage';
  private aufgabeNichtOkGemeldet$: Observable<boolean>;
  public uiZeigeAufgabeNichtOkMeldenLaden$: Observable<boolean>;
  private uiZeigeAufgabeNichtOkMeldenLadefehler$: Observable<boolean>;
  private aufgabeOkGemeldet$: Observable<boolean>;
  public uiZeigeAufgabeOkMeldenLaden$: Observable<boolean>;
  private uiZeigeAufgabeOkMeldenLadefehler$: Observable<boolean>;
  private aufgabeFreigebenGemeldet$: Observable<boolean>;
  public uiZeigeAufgabeFreigebenMeldenLaden$: Observable<boolean>;
  private uiZeigeAufgabeFreigebenMeldenLadefehler$: Observable<boolean>;
  private fehler$: Observable<apiVeranstaltungen.Fehler>;
  private aufgabeBilder: Array<BildInfo> = new Array<BildInfo>();
  private aufgabeBildLoader: Subscription;
  private bemerkungBilder: Array<BildInfo> = new Array<BildInfo>();
  private bemerkunBildLoader: Subscription;
  private fehlerBilder: Array<BildInfo> = new Array<BildInfo>();
  private fehlerBildLoader: Subscription;
  private windowLocal: Window;
  private alive = true;

  private readnew = true;

  aufgabeSegment = 'aufgabe';

  constructor(public domSanitizer: DomSanitizer,
    private storeVeranstaltung: Store<fromAppState.GlobalAppState>,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    private windowref: WindowRefService,
    private imageService: ImageService,
    private store: Store<fromAufgabenPage.PageState>,
    private zone: NgZone,
    private settingsProvider: SettingsProvider,
    public route: ActivatedRoute,
    public router: Router) {

    this.themeDefault$ = this.settingsProvider.getThemeDefault();
    this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
    this.settings$ = this.settingsProvider.getActiveTheme();
    this.windowLocal = windowref.nativeWindow;
  }

  ngOnInit() {
    this.readnew = true;
    this.aktuelleVeranstaltung$ = this.storeVeranstaltung.pipe(select(fromAppState.getAktuelleVeranstaltung));
    this.veranstaltungBerechtigung$ = this.storeVeranstaltung.pipe(select(fromAppState.getVeranstaltungBerechtigung));


    // Platform from State
    this.platformState$ = this.storeVeranstaltung.pipe(select(getPlatform));

    this.aufgabeNichtOkGemeldet$ = this.store.pipe(select(fromAufgabenPage.getAufgabeNichtOkGemeldet));
    this.uiZeigeAufgabeNichtOkMeldenLaden$ = this.store.pipe(select(fromAufgabenPage.getUiZeigeAufgabeNichtOkMeldenLaden));
    this.uiZeigeAufgabeNichtOkMeldenLadefehler$ = this.store.pipe(select(fromAufgabenPage.getUiZeigeAufgabeNichtOkMeldenLadefehler));

    this.aufgabeOkGemeldet$ = this.store.pipe(select(fromAufgabenPage.getAufgabeOkGemeldet));
    this.uiZeigeAufgabeOkMeldenLaden$ = this.store.pipe(select(fromAufgabenPage.getUiZeigeAufgabeOkMeldenLaden));
    this.uiZeigeAufgabeOkMeldenLadefehler$ = this.store.pipe(select(fromAufgabenPage.getUiZeigeAufgabeOkMeldenLadefehler));

    this.aufgabeFreigebenGemeldet$ = this.store.pipe(select(fromAufgabenPage.getAufgabeFreigebenGemeldet));
    this.uiZeigeAufgabeFreigebenMeldenLaden$ = this.store.pipe(select(fromAufgabenPage.getUiZeigeAufgabeFreigebenMeldenLaden));
    this.uiZeigeAufgabeFreigebenMeldenLadefehler$ = this.store.pipe(select(fromAufgabenPage.getUiZeigeAufgabeFreigebenMeldenLadefehler));
    this.fehler$ = this.store.pipe(select(fromAufgabenPage.getFehler));
    this.aufgabe$ = this.store.pipe(select(fromAufgabenPage.getAufgabe));
    this.aufgabeDetail$ = this.store.pipe(select(fromAufgabenPage.getAufgabeDetail));
    this.checklisteStatus$ = this.store.pipe(select(fromAufgabenPage.getChecklisteStatus));

    this.aktuelleVeranstaltung$.subscribe((aktuelleVeranstaltung) => {
      if (aktuelleVeranstaltung != null) {
        this.aktuelleVeranstaltungId = aktuelleVeranstaltung.veranstaltung_id;
        this.aktuelleVeranstaltung = aktuelleVeranstaltung;
      }
    });

    this.veranstaltungBerechtigung$.subscribe((x) => {
      if (x != null) {
        this.veranstaltungBerechtigung = x;
      }
    });

    this.platformState$.subscribe(x => {
      this.platformState = x;
      if (x === 'desktop') {
        this.viewWillEnterPage().then();
      }
    }).unsubscribe();
  }

  ionViewWillEnter() {

    // NgAfterViewInit NgAfterContentInit probieren
    // NgAfterViewChecked NgAfterContentChecked probieren
    // console.log('IONViewWillEnter!!!');
    this.destroyPage = false;
    this.viewWillEnterPage().then();
  }

  /*    ngAfterViewInit () {
          console.log('ngAfterViewInit');
          // this.viewWillEnterPage().then();
      }

      ngAfterContentInit () {
          console.log('ngAfterContentInit');
          // this.viewWillEnterPage().then();
      }

      ngAfterViewChecked () {
          if (this.readnew) {
              console.log('ngAfterViewChecked');
              this.viewWillEnterPage().then();
              this.readnew = false;
          }
      }

      ngAfterContentChecked () {
          /!*if (this.readnew) {
              console.log('ngAfterContentChecked');
              this.viewWillEnterPage().then();
              this.readnew = false;
          }*!/
      }*/

  async viewWillEnterPage() {
    console.log('AufgabePage - ViewWillEnterPage');
    this.unsubscibe$ = new Subject<void>();
    await this.store.dispatch(new actionsUi.PageStateResetAction());
    await this.route.paramMap.subscribe(async params => {
      const aufgabeId = params.get('aufgabeId');
      const veranstaltungId = params.get('veranstaltungId');
      this.aufgabe = <apiVeranstaltungen.Aufgabe>{
        veranstaltung_id: veranstaltungId,
        aufgabe_id: aufgabeId
      };
      // console.log('!!!params: ', params);

      await this.store.dispatch(new actionsUi.SetzeVeranstaltungIdAction(params.get('veranstaltungId')));
      await this.store.dispatch(new actionsUi.SetzeFunktionsbereichIdAction(params.get('checklisteId')));
      await this.store.dispatch(new actionsUi.SetzeChecklisteIdAction(params.get('checklisteId')));
      await this.store.dispatch(new actionsUi.SetzeAufgabeIdAction(params.get('aufgabeId')));
      // await this.funktionsbereichChecklistenAufgabenLaden();


      /*if (this.aufgabe !== null && this.aufgabe.aufgabe_id !== undefined && this.aufgabe.aufgabe_id !== null) {
          await this.store.dispatch(new GetAufgabeDetailAction(this.aufgabe.aufgabe_id));
      }*/
      // Wenn Fehler vorhanden, dann muss das Fehleraggregat noch geladen werden
      // await this.store.dispatch(new GetAufgabeFehlerAction(this.aufgabe.aufgabe_id));
      this.getFehler$ = this.store.pipe(select(fromAufgabenPage.getFehler), takeUntil(this.unsubscibe$)).subscribe((x: apiVeranstaltungen.Fehler) => {
        while (this.fehlerBilder.length > 0) {
          this.fehlerBilder.pop();
        }
        this.zone.run(() => {
          this.fehlerBilder = [];
          this.fehlerBilder$ = of(this.fehlerBilder);
        });

        if (x != null && x.fehler_bilder_ids.length > 0) {

          x.fehler_bilder_ids.forEach(bildId => {
            this.getFehlerBild(x.aufgabe_id, bildId)
              .pipe(
                // tap(y => console.debug(y)),
                takeWhile(() => this.alive)
                , filter(image => {
                  return !!image;
                }),
                catchError((error: any) => {
                  console.debug('ERROR :: ', error);
                  return of();
                }),
              )
              .subscribe((image: BlobPart) => {
                const imgtype = bildId.split('.')[1];
                if (image) {
                  const blob = new Blob([image]);

                  const reader = new FileReader();
                  reader.onload = function () {
                    const readerResult = reader.result.toString().replace('application/octet-stream', 'image/jpeg');
                    const imgBase64JPEG = 'data:image/' + imgtype + ';base64,' + readerResult.split('base64,')[1];
                    const bi = <BildInfo>{
                      bildId,
                      data: imgBase64JPEG,
                      dataTrusted: this.domSanitizer.bypassSecurityTrustUrl(imgBase64JPEG),
                      type: 'image/' + imgtype
                    };

                    if ((!this.fehlerBilder || this.fehlerBilder.length === 0) && x.fehler_bilder_ids && x.fehler_bilder_ids.length > 0) {
                      for (let i = 0; i < x.fehler_bilder_ids.length; i++) {
                        this.fehlerBilder[i] = null;
                      }
                    }

                    if (this.fehlerBilder.findIndex(bild => bild && bild.bildId === bildId) === -1) {
                      const index = x.fehler_bilder_ids.findIndex(y => y === bildId);
                      this.zone.run(() => {
                        this.fehlerBilder[index] = bi;
                        this.fehlerBilder$ = of(this.fehlerBilder);
                      });
                    }

                  }.bind(this);

                  reader.readAsDataURL(blob);
                }
              },
                error => {

                });
          });
        }
      });

      this.getAufgabe$ = this.store.pipe(select(fromAufgabenPage.getAufgabe), takeUntil(this.unsubscibe$)).subscribe((x: apiVeranstaltungen.Aufgabe) => {
        while (this.bemerkungBilder.length > 0) {
          this.bemerkungBilder.pop();
        }
        this.zone.run(() => {
          this.bemerkungBilder = [];
          this.bemerkungBilder$ = of(this.bemerkungBilder);
        });

        if (x != null && x.bilder_ids !== undefined && x.bilder_ids !== null && x.bilder_ids.length > 0) {

          x.bilder_ids.forEach(bildId => {
            this.getAufgabeBild(x.aufgabe_id, bildId)
              .pipe(
                takeWhile(() => this.alive)
                , filter(image => {
                  return !!image;
                }),
                catchError((error: any) => {
                  console.debug('ERROR :: ', error);
                  return of();
                }),
              )
              .subscribe((image: BlobPart) => {
                const imgtype = bildId.split('.')[1];
                if (image) {
                  const blob = new Blob([image]);

                  const reader = new FileReader();
                  reader.onload = function () {
                    const readerResult = reader.result.toString().replace('application/octet-stream', 'image/jpeg');
                    const imgBase64JPEG = 'data:image/' + imgtype + ';base64,' + readerResult.split('base64,')[1];
                    const bi = <BildInfo>{
                      bildId,
                      data: imgBase64JPEG,
                      dataTrusted: this.domSanitizer.bypassSecurityTrustUrl(imgBase64JPEG),
                      type: 'image/' + imgtype
                    };

                    if ((!this.bemerkungBilder || this.bemerkungBilder.length === 0) && x.bilder_ids && x.bilder_ids.length > 0) {
                      for (let i = 0; i < x.bilder_ids.length; i++) {
                        this.bemerkungBilder[i] = null;
                      }
                    }

                    if (this.bemerkungBilder.findIndex(bild => bild && bild.bildId === bildId) === -1) {
                      const index = x.bilder_ids.findIndex(y => y === bildId);
                      this.zone.run(() => {
                        this.bemerkungBilder[index] = bi;
                        this.bemerkungBilder$ = of(this.bemerkungBilder);
                      });
                    }

                  }.bind(this);

                  reader.readAsDataURL(blob);
                }
              },
                error => {

                });
          });
        }

        while (this.aufgabeBilder.length > 0) {
          this.aufgabeBilder.pop();
        }
        this.zone.run(() => {
          this.aufgabeBilder = [];
          this.aufgabeBilder$ = of(this.aufgabeBilder);
        });

        if (x != null && x.vorlage_bilder_ids !== undefined && x.vorlage_bilder_ids !== null && x.vorlage_bilder_ids.length > 0) {
          x.vorlage_bilder_ids.forEach(bildId => {
            this.getAufgabeBild(x.aufgabe_id, bildId)
              .pipe(
                takeWhile(() => this.alive)
                , filter(image => {
                  return !!image;
                }),
                catchError((error: any) => {
                  console.debug('ERROR :: ', error);
                  return of();
                }),
              )
              .subscribe((image: BlobPart) => {
                const imgtype = bildId.split('.')[1];
                if (image) {
                  const blob = new Blob([image]);

                  const reader = new FileReader();
                  reader.onload = function () {
                    const readerResult = reader.result.toString().replace('application/octet-stream', 'image/jpeg');
                    const imgBase64JPEG = 'data:image/' + imgtype + ';base64,' + readerResult.split('base64,')[1];
                    const bi = <BildInfo>{
                      bildId,
                      data: imgBase64JPEG,
                      dataTrusted: this.domSanitizer.bypassSecurityTrustUrl(imgBase64JPEG),
                      type: 'image/' + imgtype
                    };

                    if ((!this.aufgabeBilder || this.aufgabeBilder.length === 0) && x.vorlage_bilder_ids && x.vorlage_bilder_ids.length > 0) {
                      for (let i = 0; i < x.vorlage_bilder_ids.length; i++) {
                        this.aufgabeBilder[i] = null;
                      }
                    }

                    if (this.aufgabeBilder.findIndex(bild => bild && bild.bildId === bildId) === -1) {
                      const index = x.vorlage_bilder_ids.findIndex(y => y === bildId);
                      this.zone.run(() => {
                        this.aufgabeBilder[index] = bi;
                        this.aufgabeBilder$ = of(this.aufgabeBilder);
                      });
                    }

                  }.bind(this);

                  reader.readAsDataURL(blob);
                }
              },
                error => {

                });
          });
        }
      });
    }).unsubscribe();
  }

  ionViewWillLeave() {
    this.unsubscibe$.next();
    this.unsubscibe$.complete();
  }

  // ionViewDidLeave() {
  //     this.unsubscibe$.next();
  //     this.unsubscibe$.complete();
  // }

  // async pageAktualisieren(event) {
  //     await this.store.dispatch(new GetAufgabeDetailAction(this.aufgabe.aufgabe_id));
  //     await event.target.complete();
  // }

   pageAktualisieren(event) {
    if (this.aufgabe !== null && this.aufgabe.aufgabe_id !== undefined && this.aufgabe.aufgabe_id !== null) {
      this.store.dispatch(new GetAufgabeDetailAction(this.aufgabe.aufgabe_id));
      setTimeout( function () {
        event.target.complete();
      }.bind(this), 800);
    }
  }

  async funktionsbereichChecklistenAufgabenLaden() {
    this.store.dispatch(new GetFunktionsbereichChecklistenAufgabenAction(this.funktionsbereich.funktionsbereich_id));
  }


  async aufgabeOk(aufgabe: Aufgabe) {
    this.aufgabe = aufgabe;
    const aufgabeRequest = <apiVeranstaltungen.AufgabeRequest>{
      funktionsbereich_id: this.aufgabe.funktionsbereich_id,
      checkliste_id: this.aufgabe.checkliste_id,
      aufgabe_id: this.aufgabe.aufgabe_id,
      veranstaltung_id: this.aufgabe.veranstaltung_id,
      zeitpunkt_utc: new Date()
    };
    this.store.dispatch(new PostAufgabeOkErfassenAction(aufgabeRequest));
    // danach zur Liste über die Effekte

    // HINWEIS: Über aufgabeNichtOkGemeldet$.subject (oben) wird weitergeleitet
    if (this.platformState === 'desktop') {
      /* const params = {
           aufgabe: this.aufgabe
       };
       const modal = await this.modalCtrl.create({component: AufgabebemerkungPage, componentProps: params});
       modal.onDidDismiss().then((result: any) => {
           if (result != null && result.data) {

           }
       });

       await modal.present();*/
    } else {
      await this.router.navigate(
        ['/veranstaltung/' + this.aufgabe.veranstaltung_id + '/funktionsbereiche-checklisten/funktionsbereich/' + this.aufgabe.funktionsbereich_id + '/checkliste/' + this.aufgabe.checkliste_id],
        {
          relativeTo: this.route
        });
    }
  }

  async aufgabeNeutral(aufgabe: Aufgabe) {
    this.aufgabe = aufgabe;

    const params = {
      aufgabe: this.aufgabe,
      modus: 'aufgabeNeutral'
    };

    // danach zur Liste über die Effekte

    // HINWEIS: Über aufgabeNichtOkGemeldet$.subject (oben) wird weitergeleitet
    if (this.platformState === 'desktop') {

      const modal = await this.modalCtrl.create({ component: AufgabebemerkungPage, componentProps: params });
      modal.onDidDismiss().then((result: any) => {
        if (result != null && result.data) {

        }
      });

      await modal.present();

    } else {
      await this.router.navigate(
        ['/veranstaltung/' + this.aufgabe.veranstaltung_id + '/funktionsbereiche-checklisten/funktionsbereich/' + this.aufgabe.funktionsbereich_id + '/checkliste/' + this.aufgabe.checkliste_id],
        {
          relativeTo: this.route,
          state: params
        });
    }
  }

  async aufgabeNichtOk(aufgabe: Aufgabe) {
    this.aufgabe = aufgabe;

    const nichtOkTextOptional = this.veranstaltungBerechtigung.ist_aufgabe_nichtok_text_optional;

    if (nichtOkTextOptional) {
      // wenn nok text optional ist, dann nicht ok senden

      const aufgabeRequest = <apiVeranstaltungen.AufgabeFehlerbeschreibungRequest>{
        funktionsbereich_id: this.aufgabe.funktionsbereich_id,
        checkliste_id: this.aufgabe.checkliste_id,
        aufgabe_id: this.aufgabe.aufgabe_id,
        veranstaltung_id: this.aufgabe.veranstaltung_id,
        zeitpunkt_utc: new Date(),
        fehlerbeschreibung: ''
      };
      this.store.dispatch(new PostAufgabeNichtOkErfassenAction(aufgabeRequest));

    }

    const params = {
      aufgabe: this.aufgabe
    };

    // console.log('Aufgabe nicht ok: ', this.platformState);
    if (this.platformState === 'desktop') {

      const modal = await this.modalCtrl.create({ component: FehlerbeschreibungPage, componentProps: params });
      modal.onDidDismiss().then((result: any) => {
        if (result != null && result.data) {

        }
      });

      await modal.present();
    } else {
      await this.router.navigate(['/veranstaltung/' + this.aufgabe.veranstaltung_id + '/funktionsbereiche-checklisten/funktionsbereich/' + this.aufgabe.funktionsbereich_id + '/checkliste/' + this.aufgabe.checkliste_id + '/aufgabe/' + this.aufgabe.aufgabe_id + '/fehler'],
        {
          relativeTo: this.route,
          state: params
        }
      );
    }
  }

  async aufgabeOkKommentar(aufgabe: Aufgabe) {
    this.aufgabe = aufgabe;

    const params = {
      aufgabe: this.aufgabe,
      modus: 'aufgabeBemerkung'
    };

    if (this.platformState === 'desktop') {

      const modal = await this.modalCtrl.create({ component: AufgabebemerkungPage, componentProps: params });
      modal.onDidDismiss().then((result: any) => {
        if (result != null && result.data) {

        }
      });

      await modal.present();
    } else {
      await this.router.navigate(['/veranstaltung/' + this.aufgabe.veranstaltung_id + '/funktionsbereiche-checklisten/funktionsbereich/' + this.aufgabe.funktionsbereich_id + '/checkliste/' + this.aufgabe.checkliste_id + '/aufgabe/' + this.aufgabe.aufgabe_id + '/bemerkung'],
        {
          relativeTo: this.route,
          state: params
        }
      );
    }
  }

  async aufgabeFreigeben(aufgabe: Aufgabe) {
    this.aufgabe = aufgabe;
    const prompt = await this.alertCtrl.create({
      header: 'Aufgabe freigeben',
      message: 'Bitte nenne den Grund für die Freigabe der Aufgabe <b>' + this.aufgabe.titel + '</b>',
      inputs: [
        {
          name: 'freigabegrund',
          placeholder: 'Freigabe Grund...',
          id: 'alertInput'
        },
      ],
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => {
          }
        },
        {
          text: 'Freigeben',
          handler: data => {
            const aufgabeRequest = <apiVeranstaltungen.AufgabeFreigebenRequest>{
              funktionsbereich_id: this.aufgabe.funktionsbereich_id,
              checkliste_id: this.aufgabe.checkliste_id,
              aufgabe_id: this.aufgabe.aufgabe_id,
              veranstaltung_id: this.aufgabe.veranstaltung_id,
              freigabe_text: data.freigabegrund,
              zeitpunkt_utc: new Date()
            };
            this.store.dispatch(new PostAufgabeFreigebenAction(aufgabeRequest));

            // this.windowLocal.history.back();
          }
        }
      ],
      cssClass: 'alertCustomCss'
    });
    await prompt.present();
  }

  getAufgabeBild(aufgabeId: string, bildId: string): Observable<any> {
    const requestOptions = {
      responseType: ResponseContentType.Blob
    };
    return this.imageService.getAufgabeBemerkungBildWithHttpInfo(aufgabeId, bildId, requestOptions);
  }

  getFehlerBild(aufgabeId: string, bildId: string): Observable<any> {
    const requestOptions = {
      responseType: ResponseContentType.Blob
    };
    return this.imageService.getAufgabeFehlerBildWithHttpInfo(aufgabeId, bildId, requestOptions);
  }

  async aufgabeBilderAnzeigen(index) {
    const imageModal = await this.modalCtrl.create({
      component: BildVorschauComponent,
      componentProps: {
        bilder: this.aufgabeBilder$,
        initialImage: index,
        title: 'Vorlagenbilder'
      },
    });
    imageModal.onDidDismiss().then(data => console.debug('AufgabePage:: aufgabeBilderAnzeigen :  imageModal.onDidDismiss: ' + data));
    await imageModal.present();
  }

  async bemerkungBilderAnzeigen(index) {
    const imageModal = await this.modalCtrl.create({
      component: BildVorschauComponent,
      componentProps: {
        bilder: this.bemerkungBilder$,
        initialImage: index,
        title: 'Kommentarbilder'
      },
    });
    imageModal.onDidDismiss().then(data => console.debug('AufgabePage:: bemerkungBilderAnzeigen :  imageModal.onDidDismiss: ' + data));
    await imageModal.present();
  }

  async fehlerBilderAnzeigen(index) {
    const imageModal = await this.modalCtrl.create({
      component: BildVorschauComponent,
      componentProps: {
        bilder: this.fehlerBilder$,
        initialImage: index,
        title: 'Fehlerbilder'
      }
    });
    imageModal.onDidDismiss().then(data => console.debug('AufgabePage:: fehlerBilderAnzeigen :  imageModal.onDidDismiss: ' + data));
    await imageModal.present();
  }

}
